import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';
import store from '@/state/store';

const staticData = () => {
  store.state.companySettings;
  const shouldHideCpa = utils.checkOcultarCpa();

  const columns = [
    {
      key: 'affiliate_name',
      label: i18n.t('Affiliate')
    },
    {
      key: 'affiliate_token',
      label: 'Token'
    }
  ];

  if (!shouldHideCpa) {
    columns.push(
      {
        key: 'reward_slug',
        label: i18n.t('CPA')
      },
      {
        key: 'entry_value',
        label: i18n.t('Valor'),
        formatter: (v) => utils.formatFloat(v)
      },
      {
        key: 'qtd_cpa',
        label: i18n.t('Qtd. CPA')
      }
    );
  }

  return {
    columns
  };
};

export default staticData;
